import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { CreditCard, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/paiements-cb/carte`;

export const useConfirmCarte = (onDone) => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sid = params.get('carte_session');
    if (!sid) return;
    params.delete('carte_session');
    window.history.replaceState({}, '', `${window.location.pathname}${params.toString() ? `?${params}` : ''}`);
    axios.post(`${API}/confirm`, { session_id: sid })
      .then((r) => {
        if (r.data.success) toast.success(`Nouvelle carte enregistrée (${r.data.carte}) : vos prochaines échéances seront prélevées sur cette carte`);
        else toast.error('Enregistrement de la carte non finalisé');
        onDone?.();
      })
      .catch(() => toast.error('Enregistrement de la carte impossible'));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

export const RemplacerCarteBtn = ({ url, headers, aCarte, testId }) => {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      const r = await axios.post(url, { origin: window.location.origin }, headers ? { headers } : undefined);
      window.location.href = r.data.url;
    } catch (e) { toast.error(e.response?.data?.detail || 'Ouverture du formulaire carte impossible'); setBusy(false); }
  };
  return (
    <Button type="button" variant="outline" onClick={go} disabled={busy} className="w-full border-violet-300 text-violet-800" data-testid={testId}>
      {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <CreditCard className="h-4 w-4 mr-2" />}
      {aCarte ? 'Remplacer ma carte de prélèvement' : 'Enregistrer une carte pour le prélèvement automatique'}
    </Button>
  );
};

export const carteUrl = { rcds: (id) => `${API}/rcds/${id}`, domium: (token) => `${API}/domium/${token}` };
